import Config from "../../config/config";
import AppUser from "../app-user/app-user";

const base = Config.API_URL.replace(/\/$/, "");
const baseARIA = Config.API_URL_ARIA.replace(/\/$/, "");

export function apiUrl(route: string, mode: string = ""): string {
  if (mode === 'aria') return `${baseARIA}/${route}`;
  return `${base}${route}`;
}

export async function getAuthHeader(mode: string = "", recaptchaV3Token?: string) {
  return {
    headers: {
      Authorization: `Bearer ${mode === 'aria' ? (await AppUser.getInfo()).aria_token : (await AppUser.getInfo()).token}`,
      "recaptcha-v3": recaptchaV3Token
    }
  };
}
